module.exports = global["videojs"] = require("-!/home/dberror/projects/wjplayer/node_modules/video.js/es5/video.js");


//////////////////
// WEBPACK FOOTER
// ./~/expose-loader?videojs!./~/video.js/es5/video.js
// module id = 2
// module chunks = 0 1